module.exports = __webpack_public_path__ + "static/media/motc.3762c4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/portfolio/motc.png
// module id = 328
// module chunks = 0